export default __webpack_public_path__ + "static/media/Polo-Wear.8d8702c0.png";